import * as Sentry from '@sentry/react';
import appConfig from '../../configs/appConfig';
import { CookieUtils } from './cookies.util';
import { LocalStorageUtils } from './localStorage.util';

const orgIdOptions: Cookies.CookieAttributes = {
  domain: `${appConfig.cookieDomain}`,
  path: '/',
};

const getLastPath = (): string | undefined =>
  LocalStorageUtils.getItem<string>('lastPath');

const setLastPath = (path: string): void => LocalStorageUtils.setItem('lastPath', path);

const getPreviousOrgId = (): string | undefined =>
  LocalStorageUtils.getItem<string | undefined>('previousorgid');

const setPreviousOrgId = (id: string): void =>
  LocalStorageUtils.setItem('previousorgid', id);

const getLoginEmail = (): string | undefined =>
  LocalStorageUtils.getItem<string | undefined>('login-email');

const setLoginEmail = (id: string): void => LocalStorageUtils.setItem('login-email', id);

const removeLoginEmail = (): void => LocalStorageUtils.removeItem('login-email');

const getOrganizationId = () => {
  try {
    return CookieUtils.getCookie('organizationid');
  } catch (err) {
    Sentry.captureMessage('Error parsing cookie: organizationid', 'error');
    Sentry.captureException(err);
    return undefined;
  }
};

const clearUserSession = () => {
  const lastPath = BrowserUserSessionUtils.getLastPath();
  Sentry.setUser(null);
  try {
    CookieUtils.removeCookie('organizationid', orgIdOptions);
  } catch (err) {
    Sentry.captureMessage('Error removing cookie: organizationid', 'error');
    Sentry.captureException(err);
  }
  window.localStorage.clear();
  window.sessionStorage.clear();
  /*
When users without being loged in enter to some path that require authentication we:
  - Save that path in the local storage (eg. \o\some-portal)
  - Redirect them to /login
  - After a successful login we use the local storage value of previos path to redirect them to the path they were trying to access before loging in
  */
  if (lastPath) {
    BrowserUserSessionUtils.setLastPath(lastPath);
  }
};

export const BrowserUserSessionUtils = {
  clearUserSession,
  getOrganizationId,
  getLastPath,
  getLoginEmail,
  getPreviousOrgId,
  removeLoginEmail,
  setLastPath,
  setLoginEmail,
  setPreviousOrgId,
};
